import { render, staticRenderFns } from "./StatusIcon.vue?vue&type=template&id=47fb2b5b&scoped=true"
import script from "./StatusIcon.vue?vue&type=script&lang=ts"
export * from "./StatusIcon.vue?vue&type=script&lang=ts"
import style0 from "./StatusIcon.vue?vue&type=style&index=0&id=47fb2b5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fb2b5b",
  null
  
)

export default component.exports